import {useRouter} from "next/router";
import localized from "../../locale/locales";
import {useState} from "react";
import MainLayout from "../../components/layouts/MainLayout";
import Title from "../../components/Title";
import Typo from "../../components/Typo";
import {getCookiePreferences} from "../../helpers/cookies";
import SectionConcepts from "../../components/sections/SectionConcepts";
import SectionPersonBlock from "../../components/sections/SectionPersonBlock";
import imagePerson from "../../public/img/julian_suit.jpg";
import HeroVideo from "../../components/HeroVideo";

export default function NextBurn({hasCookiePreferences, cookiePreferences}) {
    const {locale} = useRouter();
    const {conceptsIndex: lang} = localized[locale];

    const [hiddenNav, setHiddenNav] = useState(false);

    return (
        <MainLayout hasCookiePreferences={hasCookiePreferences}
                    cookiePreferences={cookiePreferences}
                    hiddenNav={hiddenNav}
                    footerTheme="dark"
                    title={lang.og.title}
                    description={lang.og.description}
        >
            <HeroVideo size="medium"
                       mobileVideo="/videos/hero/concepts_mobile.mp4"
                       tabletVideo="/videos/hero/concepts_tablet.mp4"
                       desktopVideo="/videos/hero/concepts_desktop.mp4"
                       align="bottom"
            >
                <div className={`flex flex-col gap-4 max-w-[420px] pb-20`}>
                    <header>
                        <Title Elem="h1">{lang.header.title}</Title>
                    </header>
                    <Typo>
                        <span className="md:hidden">
                            {lang.header.body.mobile}
                        </span>
                        <span className="hidden md:inline">
                            {lang.header.body.desktop}
                        </span>
                    </Typo>
                </div>
            </HeroVideo>

            <SectionConcepts showFilters={true}/>

            <div className="pt-32 md:pt-52">
                <SectionPersonBlock
                    image={imagePerson}
                    name={lang.personBlock.person.name}
                    description={lang.personBlock.person.description}
                    title={lang.personBlock.title}
                    body={lang.personBlock.body}
                />
            </div>
        </MainLayout>
    )
}

export async function getServerSideProps({req, res}) {
    const cookiePreferences = getCookiePreferences(req);

    return {
        props: {
            ...cookiePreferences
        }
    }
}
